import React from "react";
import { Monitor, BookOpen, GraduationCap } from "lucide-react";

const links = [
    { title: "Online Classes", icon: Monitor, href: "/online-classes", description: "Access virtual learning" },
    { title: "Library Resources", icon: BookOpen, href: "/library-resources", description: "Access online libraries" },
    { title: "Academic Programmes", icon: GraduationCap, href: "/courses", description: "View our programmes" },
];

const Counts = () => (
    <section id="counts" className="py-16">
        <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {links.map((link, index) => {
                    const Icon = link.icon;
                    return (
                        <a
                            key={index}
                            href={link.href}
                            className="group flex flex-col items-center text-center gap-4 p-6 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-green-300 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
                            aria-label={`Go to ${link.title}`}
                        >
                            <div>
                                <div className="text-xl font-bold text-gray-900 group-hover:text-green-700 transition-colors">
                                    {link.title}
                                </div>
                            </div>
                            
                            <div className="flex-shrink-0 p-4 bg-gradient-to-br from-green-50 to-green-100 text-green-700 rounded-2xl group-hover:from-green-100 group-hover:to-green-200 group-hover:scale-110 transition-all duration-300">
                                <Icon className="w-8 h-8" aria-hidden="true" />
                            </div>

                            {link.description ? (
                                <div className="mt-2 text-gray-600 text-sm leading-snug">
                                    {link.description}
                                </div>
                            ) : null}
                            {link.title === "Academic Programmes" ? (
                                <div className="mt-2 text-green-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    View all programmes → </div>
                            ) : null}
                            {link.title === "Library Resources" ? (
                                <div className="mt-2 text-green-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    Access Libraries →
                                </div>) : null}
                            {link.title === "Online Classes" ? (
                                <div className="mt-2 text-green-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    Access online classes →
                                </div>) : null}
                        </a>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Counts;